import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { hasPermission } from '../../../../utility/account';
import { withUser } from '../../../../utility/withUser';
import { getOpenConversationsCount } from '../../../../utility/conversation';
import { addMessage } from '../../../../actions/messages';

/**
 * Component for showing conversations header.
 *
 * @extends React.Component
 */
class ConversationHeader extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      archivedAllowed: null,
      ongoingAllowed: null,
      open: 0,
    }
  }

  /**
   * Fetch permission to archived menu.
   */
  fetchArchivedAllowedPermission = () => {
    hasPermission(this.props.user.id, "get archived conversations", this.props.token, this.props.history, (allowed) => {
      this.setState({archivedAllowed: allowed});
    });
  }

  /**
   * Fetch permission to ongoing menu.
   */
  fetchOngoingAllowedPermission = () => {
    hasPermission(this.props.user.id, "get ongoing conversations", this.props.token, this.props.history, (allowed) => {
      this.setState({ongoingAllowed: allowed});
    });
  }

  /**
   * Fetch the open conversations count.
   */
  fetchOpenConversationsCount = () => {
    window.clearTimeout(this.updateTimeout);
    getOpenConversationsCount(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af samtaler. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        this.setState({open: data.count});
      });

      // Update open conversations count list every 5 seconds.
      window.clearTimeout(this.updateTimeout);
      this.updateTimeout = window.setTimeout(() => {
        this.fetchOpenConversationsCount();
      }, 5000);
    });
  }

  /**
   * Handle user clicking mine button.
   */
  handleClickMine = () => {
    this.props.history.push('/conversations/mine');
  }

  /**
   * Handle user clicking open button.
   */
  handleClickOpen = () => {
    this.props.history.push('/conversations/open');
  }

  /**
   * Handle user clicking archived button.
   */
  handleClickArchived = () => {
    this.props.history.push('/conversations/archived');
  }

  /**
   * Handle user clicking ongoing button.
   */
  handleClickOngoing = () => {
    this.props.history.push('/conversations/ongoing');
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchArchivedAllowedPermission();
    this.fetchOngoingAllowedPermission();
    this.fetchOpenConversationsCount();
  }
  /** @inheritdoc */
  componentWillUnmount = () => {
    window.clearTimeout(this.updateTimeout);
  }


  /** @inheritdoc */
  render() {
    var classesOpen = 'btn';
    var classesMine = 'btn';
    var classesArchived = 'btn';
    var classesOngoing = 'btn';
    if (this.props.active === 'mine') {
      classesOpen += ' btn-secondary';
      classesMine += ' btn-primary';
      classesArchived += ' btn-secondary';
      classesOngoing += ' btn-secondary';
    } else if (this.props.active === 'open') {
      classesOpen += ' btn-primary';
      classesMine += ' btn-secondary';
      classesOngoing += ' btn-secondary';
      classesArchived += ' btn-secondary';
    } else if (this.props.active === 'archived') {
      classesOpen += ' btn-secondary';
      classesMine += ' btn-secondary';
      classesArchived += ' btn-primary';
      classesOngoing += ' btn-secondary';
    } else if (this.props.active === 'ongoing') {
      classesOpen += ' btn-secondary';
      classesMine += ' btn-secondary';
      classesArchived += ' btn-secondary';
      classesOngoing += ' btn-primary';
    } else {
      classesOpen += ' btn-secondary';
      classesMine += ' btn-secondary';
      classesArchived += ' btn-secondary';
      classesOngoing += ' btn-secondary';
    }

    var openText = "Åbne";
    if (this.state.open > 0 && this.props.active !== 'open') {
      classesOpen += ' btn-danger';
    }
    if (this.state.open > 0) {
      openText += ' (' + this.state.open + ')';
    }
    return (
      <div className="row">
        <div className="col-sm-3">
          <h1>Samtaler</h1>
        </div>
        <div className="col-sm-8">
          <div className="btn-group text-center" role="group" aria-label="Samtaler">
            <button type="button" className={classesOpen} onClick={this.handleClickOpen}>{openText}</button>
            <button type="button" className={classesMine} onClick={this.handleClickMine}>Mine</button>
            {this.state.ongoingAllowed && <button type="button" className={classesOngoing} onClick={this.handleClickOngoing}>Igangværende</button>}
            {this.state.archivedAllowed && <button type="button" className={classesArchived} onClick={this.handleClickArchived}>Arkiv</button>}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(ConversationHeader));



// WEBPACK FOOTER //
// ./src/components/ConversationOverview/components/ConversationHeader/index.js